import CircularButton from "@/components/CircularButton";
import LazyLoaded from "@/components/LazyLoaded";
import { themeColors } from "@/utils/themeColors";
import { Plus } from "lucide-react";
import { useState } from "react";
import dynamic from "next/dynamic";
import { strokeWidth } from "@/utils/iconProps";

const CreateContentPopup = dynamic(() => import("@/components/popupWithSidebar/CreateContentPopup"));

export const NAV_CREATE_NEW_CONTENT_BTN_ID = "nav-create-new-content-btn";

export const clickNavbarCreateContentBtn = () => {
    setTimeout(() => {
        document.getElementById(NAV_CREATE_NEW_CONTENT_BTN_ID)?.click();
    }, 100);
};

const NavbarCreateContentBtn = () => {
    const [isCreateContentPopupOpen, setIsCreateContentPopupOpen] = useState(false);
    return (
        <>
            <CircularButton
                id={NAV_CREATE_NEW_CONTENT_BTN_ID}
                onClick={() => setIsCreateContentPopupOpen(true)}
                sx={{
                    backgroundColor: themeColors.primary,
                    color: themeColors.primaryDark,
                    height: "4rem",
                    width: "6rem",
                }}>
                <Plus strokeWidth={strokeWidth.normal} size={"2.5rem"} />
            </CircularButton>
            <LazyLoaded load={isCreateContentPopupOpen}>
                <CreateContentPopup
                    isOpen={isCreateContentPopupOpen}
                    onClose={() => setIsCreateContentPopupOpen(false)}
                />
            </LazyLoaded>
        </>
    );
};

export default NavbarCreateContentBtn;
